import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import { Bricolage_Grotesque, Public_Sans } from 'next/font/google'

const sans = Public_Sans({
    variable: '--font-sans',
    subsets: ['latin'],
    display: 'swap'
})

const heading = Bricolage_Grotesque({
    variable: '--font-heading',
    subsets: ['latin'],
    display: 'swap'
})

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className={`${sans.variable} ${heading.variable} min-h-full font-sans antialiased`}>
            <Component {...pageProps} />
        </div>
    )
}

export default App
